import { call, put } from 'redux-saga/effects'
import ActivityActions from 'Redux/ActivityRedux'
import { ActivityRespTransform } from 'Transforms/Activity'
import { BuildErrorMsg } from './ApiHelpers'

export function * onActivitiesRequest (api, action) {
  const resp = yield call(api.getActivities, action.params)
  if (resp.ok) {
    yield put(
      ActivityActions.activitiesListSuccess(
        ActivityRespTransform(resp.data), action.params.page))
  } else {
    yield put(ActivityActions.activitiesListFailure(BuildErrorMsg(resp)))
  }
}




// WEBPACK FOOTER //
// ./src/Sagas/ActivitySagas.js